import React from "react";
import ReactDOM from "react-dom";

import { useMbox } from "@swa-ui/application";
import { Shimmer } from "@swa-ui/core";
import { PageFactory } from "@swa-ui/dotcom";
import { PlacementFactory } from "@swa-ui/placements";
import {
  ManageMyVacationsWidget,
  VacationsBookingHero,
  VacationsBookingWidget,
  VacationsRecentSearch,
} from "@swa-ui/vacations";

const PAGE_LAYOUT_PLACEMENT_ID = "pageLayout";

export const LandingPagePlacements = (props) => {
  const { PageTheme, placements } = props;
  const { mbox: pageLayoutId } = useMbox("pageLayoutId", PAGE_LAYOUT_PLACEMENT_ID);

  return Array.from(placements).map((placementElement) =>
    ReactDOM.createPortal(
      <PageTheme>{renderFactory(placementElement)}</PageTheme>,
      placementElement
    )
  );

  function renderFactory(placementElement) {
    const placementId = placementElement.getAttribute("data-placement-id");
    let node = null;

    if (placementId === pageLayoutId) {
      node = <PageFactory {...getPageFactoryProps()} />;
    } else {
      node = <PlacementFactory id={placementId} />;
    }

    return node;
  }

  function renderLoading() {
    return (
      <div>
        <Shimmer height="150px" />
      </div>
    );
  }

  function getPageFactoryProps() {
    return {
      componentRenderers: {
        manageMyVacationsWidget: ManageMyVacationsWidget,
        vacationsBookingHero: VacationsBookingHero,
        vacationsBookingWidget: VacationsBookingWidget,
        vacationsRecentSearch: VacationsRecentSearch,
      },
      renderLoading,
    };
  }
};
